import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PdAnalytics from '@pagerduty/pd-segment-library';

import {
  currentUserAccountData,
  currentUserData,
  currentUserAccountFeatures,
} from '../../features/fe-data/selectors';
import { SEGMENT_WRITE_KEY } from './config';
import { noOp } from '../../util/general';

export const AnalyticsContext = React.createContext();

const AnalyticsProvider = ({
  children,
  currentUser,
  currentAccount,
  features,
  isFeDataLoaded
}) => {
  const properties = {
    name: currentUser.name,
    email: currentUser.email,
    Title: currentUser.jobTitle,
    Role: currentUser.role,
    'Created At': currentUser.createdAt,
    'Account Size': currentAccount.size,
    'Account Name': currentAccount.name,
    'Sub Domain': currentAccount.subdomain,
    'Account Created At': currentAccount.createdAt,
    'Account Plan': currentAccount.plan,
    'Account State': currentAccount.state
  };

  const initialize = async () => {
    // eslint-disable-next-line no-new
    new PdAnalytics(SEGMENT_WRITE_KEY, currentUser, currentAccount, features);
  };

  useEffect(() => {
    if (isFeDataLoaded) {
      initialize();
    }
  }, [isFeDataLoaded]);

  const safelyGetPdAnalytics = global => global.pdAnalytics || ({
    identify: noOp,
    track: noOp,
    page: noOp
  });
  const pdAnalytics = safelyGetPdAnalytics(window);

  return (
    <AnalyticsContext.Provider value={{
      identify: () => { pdAnalytics.identify(properties); },
      track: (event) => { pdAnalytics.track(event, properties); },
      page: (page) => { pdAnalytics.page(page, properties); },
      group: pdAnalytics.group
    }}
    >
      { children }
    </AnalyticsContext.Provider>
  );
};

AnalyticsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  currentUser: PropTypes.oneOfType([PropTypes.object]).isRequired,
  currentAccount: PropTypes.oneOfType([PropTypes.object]).isRequired,
  features: PropTypes.arrayOf(PropTypes.string).isRequired,
  isFeDataLoaded: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  currentUser: currentUserData(state),
  currentAccount: currentUserAccountData(state),
  features: currentUserAccountFeatures(state),
  isFeDataLoaded: state.feData.isLoaded,
});

export default connect(mapStateToProps)(AnalyticsProvider);
